import type { HTMLAttributes, ButtonHTMLAttributes } from 'react'

type Color = 'carolina' | 'green' | 'yellow' | 'red' | 'muted'

const colorClasses: Record<Color, string> = {
  carolina:
    'border-carolina/20 dark:border-carolina/15 text-carolina-dark/70 dark:text-carolina/70 bg-carolina/5',
  green:
    'border-green-400/30 text-green-600 dark:text-green-400 bg-green-400/5',
  yellow:
    'border-yellow-dark/20 dark:border-yellow/20 text-yellow-dark dark:text-yellow bg-yellow/5',
  red:
    'border-red-400/30 text-red-500 dark:text-red-400 bg-red-500/5',
  muted:
    'border-carolina/25 dark:border-carolina/15 text-steel dark:text-cream/40',
}

const activeClasses =
  'bg-carolina/20 border-carolina-dark dark:border-carolina text-carolina-dark dark:text-carolina'

const inactiveClasses =
  'border-ink/15 dark:border-cream/10 text-steel dark:text-cream/40 hover:border-carolina-dark/40 dark:hover:border-carolina/40 hover:text-carolina-dark dark:hover:text-carolina/60'

const sizeClasses = {
  sm: 'text-[14px] tracking-[1px] px-2 py-0.5',
  md: 'text-[16px] tracking-[2px] px-2.5 py-0.5',
  pill: 'text-[16px] tracking-[2px] px-3 py-1',
}

const baseClasses = 'font-mono rounded-full border uppercase transition-all'

type BadgeProps = {
  color?: Color
  size?: 'sm' | 'md' | 'pill'
} & HTMLAttributes<HTMLSpanElement>

type PressableBadgeProps = {
  active?: boolean
  size?: 'sm' | 'md' | 'pill'
} & ButtonHTMLAttributes<HTMLButtonElement>

export function Badge({
  color = 'carolina',
  size = 'md',
  className = '',
  ...props
}: BadgeProps) {
  return (
    <span
      data-component="Badge"
      className={`${baseClasses} ${colorClasses[color]} ${sizeClasses[size]} ${className}`}
      {...props}
    />
  )
}

export function PressableBadge({
  active = false,
  size = 'pill',
  className = '',
  ...props
}: PressableBadgeProps) {
  return (
    <button
      data-component="PressableBadge"
      aria-pressed={active}
      className={`${baseClasses} ${active ? activeClasses : inactiveClasses} ${sizeClasses[size]} ${className}`}
      {...props}
    />
  )
}
